<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Group</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a href="#" class="btn add-btn ml-1" @click="openDialog"
                  ><i class="fa fa-plus"></i> Add Group</a
                >
                <a href="#" class="btn add-btn ml-1" @click="openDialogImport"
                  ><i class="fa fa-plus"></i> Import Group</a
                >
                <button
                      class="btn btn-primary dropdown-toggle view-icons"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      More
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a href="#" @click="openDialogImportPayroll"
                  >Import Group Payroll</a
                >
                      <a class="dropdown-item" @click="exportSalary"
                        >Export Group Payroll</a
                      >
                    </div>
                

                
                      
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterGroup"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search Group</label>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="searchSalaryGroup"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.check`]="{ item }">
                    <router-link
                      :to="{ name: 'salarygroupattr', params: { id: item.id } }"
                      >Check Salary</router-link
                    >
                  </template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <a
                      class="dropdown-item"
                      @click="setEdit(item)"
                      data-toggle="modal"
                      data-target="#edit_department"
                      ><i class="fa fa-pencil m-r-5"></i> Edit</a
                    >
                  </template>
                  <template v-slot:[`item.delete`]="{ item }">
                    <a
                      class="dropdown-item"
                      @click="setDelete(item)"
                      data-toggle="modal"
                      data-target="#delete_department"
                      ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                    >
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->

        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Group</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Group Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model.trim="$v.name.$model"
                    id="name"
                    name="name"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.name.$error }"
                  />
                  <div
                    v-if="submitted && !$v.name.required"
                    class="invalid-feedback"
                  >
                    Group Name is required
                  </div>

                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Group</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Group Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="group.name"
                    id="name"
                    name="name"
                    class="form-control"
                  />
                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="updateGroup"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Group</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteGroup"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeDelete" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Department Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Salary Group</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Salary Group</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importGroup"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->

        <!-- Group payroll model box -->
        <v-dialog v-model="dialogImportPayroll" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Salary Group Payroll</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImportPayroll"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Salary Group Payroll</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplateGroupPayroll"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importGroupPayroll"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- Group payroll model box ends-->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { authenticationService } from "@/services/authenticationService";
import { paymentService } from "@/services/paymentService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      headers: [
        {
          text: "Group Name",
          align: "start",
          value: "name"
        },
        { text: "", value: "check", sortable: false },
        { text: "", value: "edit", sortable: false },
        { text: "", value: "delete", sortable: false }
      ],
      name: "",
      groups: [],
      group: {},
      submitted: false,
      company: authenticationService.currentOfficeValue,
      loading: false,
      error: "",
      dialog: false,
      dialogEdit: false,
      dialogImport: false,
      dialogImportPayroll: false,
      dialogDelete: false,
      file: null,
      fileName: "",
      filterGroup: ""
    };
  },
  validations: {
    name: { required }
  },

  computed: {
    searchSalaryGroup: function() {
      return this.groups.filter(
        d => d.name.toLowerCase().includes(this.filterGroup.toLowerCase())
        // : true
        // d =>
        //   d.firstName.toLowerCase().match(this.filterEmpName.toLowerCase()) ||
        //   d.lastName.toLowerCase().match(this.filterEmpName.toLowerCase())
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogImportPayroll(val) {
      val || this.closeImportPayroll();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },

  methods: {
    clearModel() {
      this.name = "";
      this.sbmitted = false;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    openDialog() {
      this.dialog = true;
    },
    openDialogImport() {
      this.dialogImport = true;
    },
    openDialogImportPayroll() {
      this.dialogImportPayroll = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeImportPayroll() {
      this.dialogImportPayroll = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEdit(model) {
      this.group = model;
      this.dialogEdit = true;
    },

    setDelete(model) {
      this.group = model;
      this.dialogDelete = true;
    },

    getGroups() {
      paymentService.getSalaryGroups(this.company.id).then(
        model => {
          this.groups = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    updateGroup() {
      this.submitted = true;

      this.loading = true;
      let id = this.group.id;
      paymentService.updateSalaryGroup(id, this.group).then(
        id => {
          paymentService.getSalaryGroups(this.company.id).then(o => {
            this.groups = o;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    setGroup(item) {
      this.group = item;
    },
    exportSalary() {
      paymentService
        .exportSalaryGroupPayrolls(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },
    downloadTemplate() {
      paymentService.downloadGroupTemplate().then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    importGroup() {
      paymentService.importGroup(this.company.id, this.file).then(
        response => {
          const companyId = this.company.id;
          paymentService.getSalaryGroups(companyId).then(o => {
            (this.elements = o),
              // console.log(o),
              this.closeImport();
          });
        },
        error => {
          this.error = error;
        }
      );
    },

    // Group payroll import and export functions starts here
    downloadTemplateGroupPayroll() {
      paymentService
        .downloadGroupPayrollTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },
    importGroupPayroll() {
      paymentService.importGroupPayroll(this.company.id, this.file).then(
        response => {
          const companyId = this.company.id;
          paymentService.getSalaryGroups(companyId).then(o => {
            (this.elements = o),
              // console.log(o),
              this.closeImport();
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    // function ends here

    deleteGroup() {
      //console.log(this.department)
      const id = this.group.id;
      paymentService.removeSalaryGroup(id).then(
        id => {
          paymentService.getSalaryGroups(this.company.id).then(o => {
            this.groups = o;
            this.closeDelete();
          });
        },
        e => {
          this.error = "Group being used in some information";
          this.closeDelete();
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      var req = {
        name: this.name,
        companyId: this.company.id
      };
      paymentService.addSalaryGroup(req).then(
        id => {
          paymentService.getSalaryGroups(this.company.id).then(o => {
            this.groups = o;
            this.close();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }

    this.getGroups();
  },
  name: "companydepartments"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/salaryGroup.vue